import React, { Dispatch, SetStateAction } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'

interface CorrectionFormState {
    newAmount: string;
    newPrincipal: string;
    newInterest: string;
    reason: string;
}

interface EmiCorrectionDialogProps {
    correctionOpen: boolean;
    setCorrectionOpen: Dispatch<SetStateAction<boolean>>;
    correctionForm: CorrectionFormState;
    setCorrectionForm: Dispatch<SetStateAction<CorrectionFormState>>;
    handleSubmitCorrectionRequest: () => void;
}


function EmiCorrectionDialog({
    correctionOpen,
    setCorrectionOpen,
    correctionForm,
    setCorrectionForm,
    handleSubmitCorrectionRequest,
}: EmiCorrectionDialogProps) {
    return (
        <>
            <Dialog open={correctionOpen} onClose={() => setCorrectionOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>🛠 Request Repayment Correction</DialogTitle>
                <DialogContent dividers>
                    <TextField
                        label="New Amount"
                        type="number"
                        fullWidth
                        margin="normal"
                        value={correctionForm.newAmount}
                        onChange={(e) => setCorrectionForm({ ...correctionForm, newAmount: e.target.value })}
                    />
                    <TextField
                        label="New Principal Component"
                        type="number"
                        fullWidth
                        margin="normal"
                        value={correctionForm.newPrincipal}
                        onChange={(e) => setCorrectionForm({ ...correctionForm, newPrincipal: e.target.value })}
                    />
                    <TextField
                        label="New Interest Component"
                        type="number"
                        fullWidth
                        margin="normal"
                        value={correctionForm.newInterest}
                        onChange={(e) => setCorrectionForm({ ...correctionForm, newInterest: e.target.value })}
                    />
                    <TextField
                        label="Reason for Correction"
                        multiline
                        rows={3}
                        fullWidth
                        margin="normal"
                        value={correctionForm.reason}
                        onChange={(e) => setCorrectionForm({ ...correctionForm, reason: e.target.value })}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCorrectionOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{
                            backgroundColor: "#4DD26B",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#b94886" }
                        }}
                        onClick={handleSubmitCorrectionRequest}
                    >
                        Submit Request
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default EmiCorrectionDialog